const HttpErrorModel = {
  BAD_REQUEST: 400,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  PAYLOAD_TO_LARGE: 413,
  UNPROCESSABLE_ENTRY: 422,
  INTERNAL_SERVER: 500,

  messages: {
    OOPS: 'Oops, something went wrong, please contact support',
  },
};

export default HttpErrorModel;
